import { useLoadScript } from '@react-google-maps/api';
import SplashScreen from 'app/components/SplashScreen';
import AppRoutes from 'app/routes/app';
import { googleMapAPIKey } from 'app/utilities/env';

function App() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: googleMapAPIKey,
    libraries: ['places'],
  });

  let content = <AppRoutes />;

  if (!isLoaded) {
    content = <SplashScreen isThemed />;
  }

  return content;
}

export default App;
